import { render, staticRenderFns } from "./MedicalTourComponent.vue?vue&type=template&id=2a93c3b1&scoped=true&"
import script from "./MedicalTourComponent.vue?vue&type=script&lang=js&"
export * from "./MedicalTourComponent.vue?vue&type=script&lang=js&"
import style0 from "./MedicalTourComponent.vue?vue&type=style&index=0&id=2a93c3b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a93c3b1",
  null
  
)

export default component.exports